import { BaseComponent2 } from '../../_common/client/base-component2';
import { CustomerReviewLightbox } from '../../_common/client/customer-review-lightbox';

export class CustomerReviewImageGalleryComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_cr-image-gallery';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;

        await CustomerReviewLightbox.init(
            this.getRootElement(),
            '.js_pdp_cr-image-gallery__images',
            '.js_pdp_cr-image-gallery__image',
            'top'
        );
    }
}
